import { combineReducers } from 'redux';

import { filters } from './filters';
import * as fromFilters from './filters';
import transitionedToFlightBookingPanel from './transitionedToFlightBookingPanel';
import * as fromTransitionedToFlightBookingPanel from './transitionedToFlightBookingPanel';

import type { AttributeType } from '@web-platform/shared-universal-constants/src/filterAttributes';
import type { FlightBookingPanelFeaturesState } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/flightBookingPanel';
import type { TransitionedToFlightBookingPanelState } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/transitionedToFlightBookingPanel';

export const createFlightBookingPanelFeaturesReducer = () =>
  combineReducers({
    filters,
    transitionedToFlightBookingPanel,
  });

export const getBookingPanelSelectedFilters = (
  state: FlightBookingPanelFeaturesState,
): AttributeType[] => fromFilters.getSelected(state.filters);

export const getTransitionedToFlightBookingPanel = (
  state: FlightBookingPanelFeaturesState,
): TransitionedToFlightBookingPanelState =>
  fromTransitionedToFlightBookingPanel.get(state.transitionedToFlightBookingPanel);
